import React, { Suspense, lazy } from 'react'
import { Header } from './pages/Header'
import { HorecaFaq } from './pages/HorecaFaq'
import { Contact } from './pages/Contact'
import { Seo } from './Seo'
import { SiteFooter } from './visualComponent/SiteFooter'

// Keep the 3D configurator in its own chunk (G12): lazy-load it here too.
const Horeca = lazy(() => import('./pages/Horeca'))

const HorecaPlaceholder = () => (
  <section style={{ minHeight: '70vh', background: '#fffaf0' }} aria-busy="true" />
)

// Dedicated, indexable HORECA page. The header IS the hero (horeca variant:
// own background image + copy), then the configurator, FAQ and order form.
export const HorecaPage = () => {
  return (
    <>
      <Seo pageKey="horeca" sub="horeca" />
      <Header variant="horeca" />
      <Suspense fallback={<HorecaPlaceholder />}>
        <Horeca />
      </Suspense>
      <HorecaFaq />
      <Contact />
      <SiteFooter />
    </>
  )
}
